import { render } from "./SaleOrderShow.vue?vue&type=template&id=5531d683&scoped=true"
import script from "./SaleOrderShow.vue?vue&type=script&lang=js"
export * from "./SaleOrderShow.vue?vue&type=script&lang=js"

import "./SaleOrderShow.vue?vue&type=style&index=0&id=5531d683&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5531d683"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/SaleOrderShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5531d683"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5531d683', __exports__)) {
    api.reload('5531d683', __exports__)
  }
  
  module.hot.accept("./SaleOrderShow.vue?vue&type=template&id=5531d683&scoped=true", () => {
    api.rerender('5531d683', render)
  })

}


export default __exports__